import { $, $$ } from 'utils/dom';
import Autosuggest from 'modules/autosuggest/autosuggest';

const formfilters = $$('.form-filter');
if (formfilters.length) {
  formfilters.forEach(formfilter => {
    const form = $('.form-filter__forms', formfilter);
    const input = $('.input__input', formfilter);
    const selectFields = $$('.select__select', formfilter);

    selectFields.forEach(select => {
      select.addEventListener('change', () => {
        form.submit();
      });
    });

    new Autosuggest({
      input,
      form,
      preventSubmit: false,
      allowEmptySubmit: true,
      onlySubmittingIfSuggestion: false,
      onSelecting: () => {
        form.submit();
      },
      textMinLength: 2,
    }).init();
  });
}
